import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import "./NewUserModal.css"
import { useState } from 'react';
import Swal from "sweetalert2";
import Select from 'react-select';


const NewUserModal = ({ show, requestClose }) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;

    //SESSION OBJECT
    const sessionUser = JSON.parse(sessionStorage.getItem("userSession"));

    //INPUTS CONTROLS
    const [name, setName] = useState(null);
    const [userName, setUserName] = useState(null);
    const [userGroup, setUserGroup] = useState(null);
    const [userMail, setUserMail] = useState(null);
    const [userCompany, setUserCompany] = useState(null);


    //
    const [userGroupsCombo, setUserGroupsCombo] = useState([]);


    const getUsersGroupsListing = async () =>{

        const endpoint = "getUsersGroupsListing";
        
        const response = await fetch(apiUrl + endpoint,
        {
            method: "GET",
            headers: {"Content-Type": "application/json"}
        });

        const responseContent = await response.json();
        console.log(responseContent);

        setUserGroupsCombo(responseContent);


    } //END FUNCTION

    const addNewUser = async () => {

        //MAIN VALIDATION

        //EMPRESA O NOMBRE
        if(!userCompany && !name){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Debe indicar empresa o nombre del cliente.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;

        }


        if(!userName || !userGroup){

            //Show message sweet alert
            Swal.fire({
                title: "Datos Faltantes",
                text: "Faltan datos obligatorios por completar.",
                icon: "warning",
                confirmButtonText: "OK"
            });

            return;
        }//

        //
        if(!userMail) { userMail = "N/A"; }

        const metadata = {
            "customer_name": name ? name.replace(/[\t\\']/g, '').trim() : "",
            "email": userMail ? userMail.replace(/[\t\\']/g, '').trim() : "",
            "username": userName ? userName.replace(/[\t\\']/g, '').trim() : "",
            "group_id": userGroup,
            "observations":""
            
        };

        //
        if(userGroup === "2001"){ metadata.is_company = userCompany; }
        else { metadata.is_company = 0; }

        console.log(metadata);

        
        const endpoint = "addUser";

        const response = await fetch(apiUrl + endpoint,
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(metadata)
        });

        const responseContent = await response.json();

        if(responseContent.code == 403){

            Swal.fire({
                title: "Error!",
                text: responseContent.message,
                icon: "error",
                confirmButtonText: "OK"
            });

        } else if(responseContent.code == 500){

            //Show message sweet alert
            Swal.fire({
                title: "Error!",
                text: responseContent.message,
                icon: "error",
                confirmButtonText: "OK"
            });


        } else if(responseContent.code == 200){

            //Show message sweet alert
            Swal.fire({
                title: "¡Éxito!",
                text: "Operación realizada exitosamente.",
                icon: "success",
                confirmButtonText: "OK"
            });

            //CLOSE MODAL
            requestClose(false);

        }

    } //
    

    const onModalShow = () => {

        getUsersGroupsListing(); 

        //COMPANY DEFAULT
        setUserCompany(1);

    } //END FUNCTION

    

    return (
        <>
        <Modal show={show} onShow={onModalShow} onHide={requestClose} className={'mainOrderModal'}>
            <Modal.Header closeButton style={{borderTop:'10px solid #404661'}}>
                <Modal.Title className={'newOrderTitle'}>Agregar Nuevo Usuario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row>
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Grupo</Form.Label>
                             <Form.Select style={{fontSize:"14px"}} onChange={(e)=>{setUserGroup(e.target.value); }}>
                               <option style={{fontSize:"14px"}}>Seleccione...</option>
                                {userGroupsCombo.map((item)=>{

                                    return(
                                        <option style={{fontSize:"14px"}} value={item.id}>{item.group_name}</option>
                                    )

                                })}
                               
                            </Form.Select> <br />
                        </Form.Group>
                    </Col>

                    {userGroup === "2001" ? (
                        <Col xs={12}>
                            <Form.Label className={'newOrderlabels'}>Tipo de Cliente</Form.Label>
                                <Form.Select style={{fontSize:"14px"}} onChange={(e)=>{setUserCompany(e.target.value); }}>
                                    <option style={{fontSize:"14px"}} value="1" selected>Persona Jurídica</option>
                                    <option style={{fontSize:"14px"}} value="0">Consumidor Final</option>
                                </Form.Select> <br />
                        </Col>
                    ) : "" }
                    

                    <Col xs={12}>
                        <Form.Group>
                            <Form.Label className={'newOrderlabels'}>
                                { userGroup === "2001" ? (userCompany === "0" ? "Nombre Cliente" : "Empresa") : "Nombre Usuario" }
                            </Form.Label>
                            <Form.Control 
                            type="text" 
                            placeholder={ userGroup === "2001" ? (userCompany === "0" ? "Nombre Cliente..." : "Empresa...") : "Nombre Usuario..." }
                            onChange={(event)=> setName(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                   
                   
                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Username</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="Username (login)" 
                             onChange={(event)=> setUserName(event.target.value)} /><br />
                        </Form.Group>
                    </Col>

                    
                    

                    <Col xs={12}>
                        <Form.Group>
                             <Form.Label className={'newOrderlabels'}>Contacto / E-Mail</Form.Label>
                             <Form.Control 
                             type="text" 
                             placeholder="E-Mail" 
                             onChange={(event)=> setUserMail(event.target.value)} /><br />
                        </Form.Group>
                    </Col>
                    
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="danger" onClick={requestClose} size='sm'>
                Cerrar Ventana
            </Button>
            <Button 
                variant="success" 
                size='sm'
                onClick={addNewUser}
                >

                Guardar Datos
            </Button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default NewUserModal;